import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PrometricParticipationAgreementDataServiceService {
   baseUrl: string = environment.API_URL;
      serviceBase = this.baseUrl + '/api/prometricParticipationAgreement';
  
  queryString: string;

  constructor(private http: HttpClient) { }

  getParticipationAgreement(email: string) {
    this.queryString = '/getParticipationAgreement?email=' + email;
    return this.http.get<any>(this.serviceBase + this.queryString);
  }

  sendPrometricAgreementOTP(email: string) {
    this.queryString = '/sendPrometricAgreementOTP?email=' + email;
    return this.http.get<any>(this.serviceBase + this.queryString);
  }

  savePrometricParticipationAgreement(participationAgreement: any) {
    this.queryString = '/saveParticipationAgreement';
    return this.http.post<any>(this.serviceBase + this.queryString, participationAgreement);
  }

  saveAdditionalEmailIds(participationAgreement: any) {
    this.queryString = '/saveAdditionalEmailIds';
    return this.http.post<any>(this.serviceBase + this.queryString, participationAgreement);
  }

  checkValidCode(email: any, optValue: any) {
    this.queryString = '/checkValidCode?email=' + email + '&optValue=' + optValue;
    return this.http.get<any>(this.serviceBase + this.queryString);
  }

  getCountries(selectedLanguage: any) {
    return this.http.get('/api/prometricParticipationAgreement/getCountries?selectedLanguage=' + selectedLanguage);
  }

}
